module.exports = __webpack_public_path__ + "img/Z81_20.243871f5.jpg";